import React, { useContext } from 'react'
import Loader from '../Components/Loader/Loader'
import Footer from '../Components/footer/Footer'
import Header from '../Components/header/Header'
import Layout from '../Components/layout/Layout'
import Navbar from '../Components/navbar/Navbar'
import { EthersContext } from '../Context/EthersContext'
import { Contents } from '../Utils/contents'
import Watch from '../Components/Watch/Watch'
function HomePage() {
  const { isLoading } = useContext(EthersContext)
  let layout = 1
  return (
    isLoading ? <Loader /> :
      <div >
        <div >
          <Navbar />
          <Header />
        </div>
        {
          Contents.map((content,index)=>{
            if (index === 5) return (<div className='watch_main'><a href='https://hiphopcryptowatch.com/' target='_blank'><button className='button-64' role="button"><span class="text">Check out market blog</span></button></a></div>)
            if(layout === 0) layout=1
            else layout = 0 
            return(
              <Layout height={content.height}
            heading= {content.heading}
            text= {content.text}
            layout= {layout}
            image= {content.image}
            index={index}
            />
          )})
        }
        <Watch/>
        
        <Footer />
      </div>
  )
}

export default HomePage

